/**
 * Click-to-load video facade for the article mission-video band.
 *
 * The poster + play button are the only things on the page at load time. The
 * real player sits in an inert <template>; pressing play clones it into the
 * frame and drops the facade. The frame keeps its aspect-ratio box throughout,
 * so the swap costs no layout shift.
 */
(function () {
  'use strict';

  function activate(frame) {
    var template = frame.querySelector('template[data-video-player]');
    if (!template) return;

    var facade = frame.querySelector('[data-video-facade]');

    frame.appendChild(template.content.cloneNode(true));
    if (facade && facade.parentNode) facade.parentNode.removeChild(facade);
    frame.classList.add('is-playing');

    // The click is a user gesture, so an explicit play() is allowed even when
    // the autoplay attribute alone would be blocked.
    var video = frame.querySelector('video');
    if (video && typeof video.play === 'function') {
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch(function () {});
      }
    }

    // Keyboard users pressed a button that no longer exists — move focus onto
    // the player rather than dumping them back at the top of the document.
    var player = frame.querySelector('iframe, video');
    if (player) {
      player.setAttribute('tabindex', '-1');
      try {
        player.focus({ preventScroll: true });
      } catch (error) {
        player.focus();
      }
    }
  }

  function bind(frame) {
    if (frame.getAttribute('data-aed-video-bound') === 'true') return;
    frame.setAttribute('data-aed-video-bound', 'true');

    var button = frame.querySelector('[data-video-play]');
    if (!button) return;

    button.addEventListener(
      'click',
      function () {
        activate(frame);
      },
      { once: true }
    );
  }

  function init(root) {
    var scope = root || document;
    var frames = scope.querySelectorAll('[data-aed-video]');
    for (var i = 0; i < frames.length; i++) bind(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
